import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class WhatsAppReportService {
  private apiUrl: string = environment.apiUrl;
  private currentUser: any;

  constructor(private http: HttpClient) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
  }

  getSentMessageReports(filters: any, salon): Observable<any> {
    // alert(salon)
    return this.http.post<any>(`${this.apiUrl}getSentMessageReports`, JSON.stringify({
      ...filters,
      salon_id: salon,
      currentUser: this.currentUser
    }))
      .map(response => {
        if (response && response.data) {
          return response;
        }
        return { data: [] };
      });
  }

  getCampaignReports(filters: any, salon_id): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}getCampaignReports`, JSON.stringify({
      ...filters,
      salon_id: salon_id,
      currentUser: this.currentUser
    }))
      .map(response => {
        if (response && response.data) {
          return response;
        }
        return { data: [] };
      });
  }
}


// WEBPACK FOOTER //
// ./src/app/services/whatsapp-report.service.ts